import { NextRouter } from 'next/router';

import { isSomeEnum } from '@r1-frontend/shared/guards/isSomeEnum';

import { ITariff } from '~/src/entities/formattedTariff';
import { CINEMA_CONTENT_IDS } from '~/src/features/index/Tariffs';

export enum ETariffTypes {
    FILTER_BUNDLE = 'bundle',
    FILTER_INTERNET = 'mono',
    ALL = 'all',
}

export enum EFilterIds {
    FILTER_BUNDLE = 'bundle',
    FILTER_INTERNET = 'mono',
    FILTER_ONLINE_CINEMA = 'online-cinema',
    FILTER_GAMES_AND_SERVICES = 'games-and-services',
}

type TTariffAction = (tariffs: ITariff[]) => ITariff[];

interface IFilterItem {
    id: string,
    checked: boolean,
    disabled: boolean,
    label: string,
    alternative: boolean,
    action: TTariffAction,
}

const filterActions: Record<EFilterIds, TTariffAction> = {
    [EFilterIds.FILTER_BUNDLE]: (tariffs) => tariffs.filter(tariff => tariff.type === 'bundles'),
    [EFilterIds.FILTER_INTERNET]: (tariffs) => tariffs.filter(tariff => tariff.type === 'internet'),
    [EFilterIds.FILTER_ONLINE_CINEMA]: tariffs => tariffs.filter(
        tariff => tariff.offerContents.some(
            item => item.service_id && CINEMA_CONTENT_IDS.includes(item.service_id),
        ) || tariff.title.startsWith('Развлекательный'),
    ),
    [EFilterIds.FILTER_GAMES_AND_SERVICES]: (tariffs) => tariffs.filter(tariff => tariff.title.startsWith('Гейминг') || tariff.title.startsWith('Развлекательный')),
};

export const getFilterItems = (): IFilterItem[] => ([
    {
        id: EFilterIds.FILTER_BUNDLE,
        checked: false,
        disabled: false,
        label: 'С телевидением',
        alternative: true,
        action: filterActions[EFilterIds.FILTER_BUNDLE],
    },
    {
        id: EFilterIds.FILTER_INTERNET,
        checked: false,
        disabled: false,
        label: 'Только интернет',
        alternative: true,
        action: filterActions[EFilterIds.FILTER_INTERNET],
    },
    {
        id: EFilterIds.FILTER_ONLINE_CINEMA,
        checked: false,
        disabled: false,
        label: 'Онлайн-кинотеатры',
        alternative: false,
        action: filterActions[EFilterIds.FILTER_ONLINE_CINEMA],
    },
    {
        id: EFilterIds.FILTER_GAMES_AND_SERVICES,
        checked: false,
        disabled: false,
        label: 'Игры и полезные сервисы',
        alternative: false,
        action: filterActions[EFilterIds.FILTER_GAMES_AND_SERVICES],
    },
]);

export const getInitialFilterItems = (checkedId?: ETariffTypes, currentRoute?: string): IFilterItem[]  => {
    const initItems = getFilterItems();
    const routesWithLimitedFilters = ['/internet', '/internet/mono-village'];

    return (
        (routesWithLimitedFilters.includes(currentRoute ?? '') ? initItems.slice(0, 2) : initItems).map(item => ({
            ...item,
            checked: item.id === checkedId,
        }))
    );
};

/* Оставляет только значения которые соответствуют перечислению ETariffTypes */
export const returnOnlyEnumValues = (values?: string | string[]): ETariffTypes[] => {
    if (!values) {
        return [];
    }

    const isMyEnum = isSomeEnum(ETariffTypes);

    if (Array.isArray(values)) {
        return values.reduce((acc: ETariffTypes[], curr) => {

            if (isMyEnum(curr)) {
                acc.push(curr);
            }

            return acc;
        }, []);
    }

    if (isMyEnum(values)) {
        return [values];
    }

    return [];
};

interface ITariffQueryParams {
    tariffType?: ETariffTypes,
}

export const getTariffTypeParam = (params: NextRouter['query']): ITariffQueryParams => {
    if (!params) {
        return {};
    }

    const [firstValue] = returnOnlyEnumValues(params.tariffType);

    return {
        tariffType: firstValue,
    };
};
